import { render, staticRenderFns } from "./tickets-status.vue?vue&type=template&id=2eb90ae7&"
import script from "./tickets-status.vue?vue&type=script&lang=js&"
export * from "./tickets-status.vue?vue&type=script&lang=js&"
import style0 from "./tickets-status.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports